// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"bb369a25","539":"06ea2d11","787":"d5ad62f5"}[chunkId] + ".chunk.js";
};